
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 3a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2zm5 2a1 1 0 011 1v12a1 1 0 01-1 1h-1V5h1zM7.174 10H5.5v4.284h1.116v-1.632h.39c.46 0 .809-.111 1.047-.333.238-.222.357-.555.357-.999a1.81 1.81 0 00-.072-.522 1.065 1.065 0 00-.612-.696A1.373 1.373 0 007.174 10zm3.21 0h-1.62v4.284h1.62c.324 0 .576-.059.756-.177.18-.118.315-.276.405-.474.09-.198.145-.426.165-.684a10.45 10.45 0 000-1.614 2.021 2.021 0 00-.165-.684 1.099 1.099 0 00-.405-.474c-.18-.118-.432-.177-.756-.177zm4.362 0h-2.538v4.284h1.116V12.52h1.332v-.876h-1.332v-.732h1.422V10zm-4.644.804c.108 0 .194.015.258.045s.113.093.147.189c.034.096.056.232.066.408.01.176.015.408.015.696s-.005.52-.015.696a1.54 1.54 0 01-.066.408c-.034.096-.083.159-.147.189a.616.616 0 01-.258.045H9.88v-2.676h.222zm-3.276 0c.288 0 .432.174.432.522 0 .18-.037.312-.111.396-.074.084-.181.126-.321.126h-.21v-1.044h.21z","fill-rule":"evenodd"}})])
          )
        }
      }
    